import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { ActionLink, UIHeading2, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './OffersSuggestionsLayout.css';

interface IOffersSuggestionsLayoutProps {
  title: string;
  subtitle: string;
  buttonTitle: string;
  onShow: () => void;
  onAllClick: () => void;
}

export const OffersSuggestionsLayout: React.FC<React.PropsWithChildren<IOffersSuggestionsLayoutProps>> = ({
  children,
  title,
  subtitle,
  buttonTitle,
  onShow,
  onAllClick,
}) => {
  return (
    <ActionAfterViewObserver callback={onShow} percentVisible={0.7} triggerOnce>
      <div data-testid="OffersSuggestionsLayout" className={styles['container']}>
        <div className={styles['title']}>
          <UIHeading2>{title}</UIHeading2>
          <ActionLink onClick={onAllClick} color="current_color">
            {buttonTitle}
          </ActionLink>
        </div>
        <UIText1 color="text-secondary-default">{subtitle}</UIText1>
        <ul className={styles['list']}>{children}</ul>
      </div>
    </ActionAfterViewObserver>
  );
};
